"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = respToJson;
/**
 * Convert fetch result to json
 * @param {Object} response fetch response object
 * @return {Objcet} json data.
 */
function respToJson(response) {
  if (!response.ok) {
    throw Error(response.statusText);
  }
  return response.json();
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/ntnu-react/util/respToJson.js
// module id = 314
// module chunks = 0